<template>
  <div style="height: 100%; position: relative" class="mapDiv">
    <div class="lengend">
      <div class="flex-around topNav">
        <div class="box">
          <div class="flex warn-table" v-if="btmList.length > 0">
            <div
              class="table flex"
              v-for="(it, index) in btmList"
              :key="index"
              @click="chooseNav(it.type)"
            >
              <img :src="it.pic" class="img" />
              <span style="margin-left: 5px">{{ it.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <map-nav-bar :btmList="btmList" /> -->
    <div class="zhwl-map-btn" @click="showZzglMap()">种植管理</div>
    <div id="map" class="map"></div>
    <c-detail
      v-if="JSON.stringify(poisiton) !== '{}'"
      :form="poisiton"
      class="detail"
    ></c-detail>
    <c-name
      v-if="JSON.stringify(param) !== '{}'"
      :param="param"
      class="detail"
    ></c-name>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import L from "leaflet";
// import "leaflet/dist/leaflet.css";
import cDetail from "../util/detail";
import cName from "../util/name";
import changeMap from "../util/changeMap";
import { getMMLZDPZHWL, findPestWarningAll } from "@/api/map";
import { get } from "@/api/index";
// import { mapGetters } from "vuex";
export default {
  components: {
    cDetail,
    cName
  },
  // computed: {
  //   ...mapGetters(["layerComponent"])
  // },
  // watch: {
  //   layerComponent(val) {
  //     this.delPoint();
  //     this.pointChoose(val);
  //   }
  // },
  data() {
    return {
      rightPath: "zhwlDrawer",
      type: "",
      map: null,
      param: {},
      daiArr: [],
      jdArr: [],
      kjArr: [],
      zhwlArr: [],
      hoverList: [],
      ncIndex: null,
      ncCode: "",
      poisiton: {},
      pointList: [],
      baseList: [],
      zhwlList: [],
      hoverArr: [],
      beltObj: {},
      areaList: [],
      pointAnchor: [20, 50],
      baseAnchor: [10, 50],
      mianArr: [],
      btmList: [
        {
          name: "气象站",
          pic: require("images/map/weather.png"),
          type: "weather"
        },
        {
          name: "墒情监测站&农情监测",
          pic: require("images/map/soil.png"),
          type: "soil"
        },
        // { // 2022-04-19 应要求删除
        //   name: "环境监测",
        //   pic: require("images/map/env.png"),
        //   type: "env"
        // },
        // { // 应要合并了
        //   name: "农情监测",
        //   pic: require("images/map/nq.png"),
        //   type: "nq"
        // },
        {
          name: "视频监控",
          pic: require("images/map/video.png"),
          type: "video"
        },
        {
          name: "虫情测报",
          pic: require("images/map/pest_min.png"),
          type: "pest"
        },
        {
          name: "虫情预警",
          pic: require("images/map/icon_zq_min.png"),
          type: "cqyj"
        }
      ]
    };
  },
  created() {
    console.log("on create!");
  },
  mounted() {
    console.log("on mounted");
    this.initMap();
  },
  methods: {
    initMap() {
      var url = require("images/map/dt1.png");
      var map = L.map("map", {
        minZoom: 17,
        maxZoom: 20,
        center: [-0.00200653076171875, 0.0021896362304687],
        zoom: 17,
        crs: L.CRS.Simple,
        attributionControl: false
      });
      this.map = map; //data上需要挂载
      window.map = map;
      var northEast = this.map.unproject([2271, 0], this.map.getMaxZoom() - 1); //东北 右上角northEast
      var southWest = this.map.unproject([0, 2406], this.map.getMaxZoom() - 1); //西南 左下角southWest
      var bounds = new L.LatLngBounds(southWest, northEast);
      L.imageOverlay(url, bounds, { interactive: false }).addTo(map);
      // map.setMaxBounds(bounds);//设置了地图和图片一样大小，取消之后，自定义地图可以随意拖拽
      this.dataLoad();
      this.nowZoom = this.map.getZoom();
      map.on("click", e => {
        console.log(e.latlng);
      });
      map.on("move", () => {
        this.param = {};
      });
    },
    //加载标记点数据
    dataLoad() {
      // add 虫情点
      //   var czIcon = L.icon({
      //     iconUrl: require("images/map/icon_zq.png"),
      //     iconSize: [44, 44],
      //     iconAnchor: [22, 44]
      //   });
      //   L.marker([-0.0022615826734576966, 0.002552032470703125], {
      //     icon: czIcon
      //   }).addTo(this.map);
      //智慧物联点列表
      getMMLZDPZHWL()
        .then(res => {
          console.log("智慧物联点列表 ok");
          if (res.code == 200) {
            this.zhwlList = res.data.map(e => {
              if (
                process.env.NODE_ENV === "prod1" &&
                e.type == "video" &&
                e.url
              ) {
                e.url = e.url.replace(
                  "http://hls01open.ys7.com",
                  "https://" + location.host + "/mm/m-screen/zt/zlcy"
                );
              }
              return e;
            });
            this.zhwlLoad();
          }
          window.$loading && window.$loading.close();
        })
        .catch(() => {
          window.$loading && window.$loading.close();
        });

      findPestWarningAll().then(res => {
        this.pointList = res.data.map(e => {
          return {
            id: e.id,
            longitude: e.longitude,
            latitude: e.latitude,
            name: e.type
          };
        });
        console.log("findPestWarningAll ok");
        this.pointLoad();
      });
    },

    //智慧物联点加载
    zhwlLoad() {
      this.zhwlArr = [];
      this.zhwlList.map(it => {
        if (it.latitude) {
          let aPoint = new changeMap(it.latitude, it.longitude);
          it.lat = aPoint.lat;
          it.lng = aPoint.lng;
          let pointUrl = require("images/map/" + it.type + ".png");
          var myIcons;
          this.$set(it, "color", "");
          if (it.type === "env") {
            it.color = "#F68314";
          } else if (it.type === "nq") {
            it.color = "#09b591";
          } else if (it.type === "weather") {
            it.color = "#005cc3";
          } else if (it.type === "soil") {
            it.color = "#1b98f4";
          } else if (it.type === "video") {
            it.color = "#fe6000";
          } else {
            it.color = "#F68314";
          }
          // html:
          //     "<div class='indicator-box'><img src='" +
          //     pointUrl +
          //     "' /><span class='my-div-names' style='background:" +
          //     it.color +
          //     "'>" +
          //     it.name +
          //     "</span ></div>",
          myIcons = L.divIcon({
            html:
              "<div class='indicator-box'><img src='" + pointUrl + "' /></div>",
            className: "my-div-icon",
            iconAnchor: this.baseAnchor
          });
          let zhwlLayer = L.marker([it.lat, it.lng], {
            interactive: true,
            icon: myIcons,
            attributes: it
          }).addTo(this.map);
          this.zhwlArr.push(zhwlLayer);
          zhwlLayer.on("click", e => {
            sessionStorage.setItem("rightComponent", this.rightPath);
            this.$store.dispatch(
              "drawer/setGraphic",
              e.sourceTarget.options.attributes
            );
            this.$store.dispatch("drawer/setRightComponent", it.type);
          });
          zhwlLayer.on("mouseover", it => {
            this.param = {
              x: it.containerPoint.x,
              y: it.containerPoint.y,
              name: it.sourceTarget.options.attributes.name
            };
            this.ncCode = it.target.options.attributes.code;
          });
          zhwlLayer.on("mouseout", () => {
            this.param = {};
          });
        }
      });
    },

    pointLoad() {
      if (this.pointLayer) {
        this.map.removeLayer(this.pointLayer);
      }
      this.pointLayer = new L.layerGroup();
      console.log("pointList", this.pointList);
      this.pointList.map(it => {
        if (it.latitude) {
          let aPoint = new changeMap(it.latitude, it.longitude);
          it.lat = aPoint.lat;
          it.lng = aPoint.lng;
          //   let pointUrl = require("images/map/icon_zq.png");
          //   var myIcons = "";
          //   myIcons = L.divIcon({
          //     html:
          //       "<div class='indicator-box'><div class='zhu-div-box'><img class='zhu-div-image' src='" +
          //       pointUrl +
          //       "'/><div class='zhu-div-text zhu-div-name zhu-yellow' ><span class='zhus-div-name hide yellow'>" +
          //       it.name +
          //       "</span></div></div></div>",
          //     className: "zhu-div-icon"
          //   });

          var czIcon = L.icon({
            iconUrl: require("images/map/icon_zq.png"),
            iconSize: [44, 44],
            iconAnchor: [22, 44]
          });
          let pointLayer = L.marker([it.lat, it.lng], {
            icon: czIcon,
            iconSize: [44, 44],
            iconAnchor: [22, 44],
            attributes: it
          }).addTo(this.pointLayer);
          //   this.kjArr.push(this.pointLayer);
          pointLayer.on("click", e => {
            const data = e.sourceTarget.options.attributes;
            get("/api/restful/findPestWarningById", {
              id: data.id
            }).then(res => {
              sessionStorage.setItem("rightComponent", this.rightPath);
              this.$store.dispatch("drawer/setGraphic", res.data);
              this.$store.dispatch("drawer/setRightComponent", "cqDrawer");
            });
          });
          //   pointLayer.on("mouseover", it => {
          //     it.sourceTarget
          //       .getElement()
          //       .querySelector(".zhus-div-name")
          //       .classList.remove("hide");
          //   });
          //   pointLayer.on("mouseout", it => {
          //     it.sourceTarget
          //       .getElement()
          //       .querySelector(".zhus-div-name")
          //       .classList.add("hide");
          //   });
        }
      });
      this.map.addLayer(this.pointLayer);
    },
    chooseNav(type) {
      this.delPoint();
      //   if (type === "pest") {
      //     //虫情测报进入
      //     this.$store.dispatch("drawer/setRightComponent", "pest");
      //     return;
      //   }

      if (type !== "cqyj") {
        getMMLZDPZHWL({ type }).then(res => {
          if (res.code == 200) {
            this.zhwlList = res.data;
            this.zhwlLoad();
          }
        });
      } else {
        findPestWarningAll().then(res => {
          this.pointList = res.data.map(e => {
            return {
              id: e.id,
              longitude: e.longitude,
              latitude: e.latitude,
              name: e.type
            };
          });
          this.pointLoad();
        });
      }
    },

    // //移除地图上的点
    delPoint() {
      // 虫情预警
      if (this.pointLayer) {
        this.map.removeLayer(this.pointLayer);
      }
      this.pointLayer = new L.layerGroup();
      //智慧物联点
      this.zhwlArr.forEach(e => {
        this.map.removeLayer(e);
      });
    },
    showZzglMap() {
      window.$loading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
      this.$store.dispatch("map/setMapComponent", "yzMap");
      this.$store.dispatch("drawer/setNavComponent", "navDrawer");
    }

    // //点图层选择
    // pointChoose(val) {
    //   if (val === "baseLayer") {
    //     this.pointLoad();
    //     this.baseLoad();
    //   } else if (val === "zhwlLayer") {
    //     this.zhwlLoad();
    //   }
    // }
  },
  destroyed() {
    clearInterval(this.timer);
  }
};
</script>

<style lang="stylus" scoped>
.map
    background none !important
    width 100%
    height calc(100% + 105px)
    z-index 9

    // >>>.leaflet-tile-pane
    // display none
    >>>.leaflet-bar
        display none

    >>>.leaflet-bottom
        display none

    .ncDetail
        position absolute
    >>>
        .my-div-icon
            color #fff
            z-index 970 !important

        .indicator-box
            position relative

        .my-div-name
            font-size .08rem
            border 1px #fff solid
            border-radius 5px
            background-color rgba(15, 62, 112, .8)
            padding 2px 8px

        .my-div-name:hover
            z-index 999
            font-size .09rem

        .my-div-names
            font-size .07rem
            color #FFF
            position absolute
            top -30px
            left 15px
            width max-content
            // text-shadow -1px 0 #FF770C, 0 1px #FF770C, 1px 0 #FF770C, 0 -1px #FF770C
            padding .01rem .06rem
            border-bottom-left-radius 10px
            border-top-right-radius 10px
            background #F68314
            transform translateX(-50%)

.zhwl-map-btn
  position absolute
  top 20%
  right 27%
  z-index 10000
  padding 8px 14px
  font-size 14px
  color #fff
  border-radius 4px
  border 1px solid #00b1cf
  background-color rgba(1,30,47,0.8)
  box-shadow inset 0 0 10px #00b1cf
  cursor pointer

.lengend
  position absolute
  color #fff
  z-index 10
  bottom 5px
  left 26.5%
  width 8.8%
  padding 5px
  border 1px solid #00A9C7
  background-color rgba(1,29,46, 0.8)
  box-shadow inset 0 0 0.05208rem #00b1cf
  border-radius 5px
  font-size 0.08rem
  >>>.el-checkbox__inner
    border-color #1EC4F8
  >>>.el-checkbox__input.is-checked
    border-color #1EC4F8
.mainList
  flex-wrap wrap
  width 100%
  height 100%
.lengCube
  width 50%
  height 23%
.lengCube:last-child
  padding-bottom 0
.imggs
  width 36px
  display flex
  justify-content center
  margin-right 5px
@media (min-height 1400px)
  .lengend
    font-size 0.06rem
    padding 5px 20px
.topNav
  z-index 9
  color #ccc
  display flex
  flex-direction column
  width 100%
  height 100%
  display flex


.active
  color #fff
  background-color #0D719F
.box
  width 100%
.warn-table
  padding 5px 0 5px 7px
  height calc(100% - 10px)
  overflow-y auto
  flex-wrap wrap
  &::-webkit-scrollbar
    width 4px
    background-color #19295a
  /* 定义滚动条轨道 内阴影+圆角 */
  &::-webkit-scrollbar-track
    -webkit-box-shadow inset 0 0 6px transparent
    background-color transparent
  /* 定义滑块 内阴影+圆角 */
  &::-webkit-scrollbar-thumb
    border-radius 10px
    -webkit-box-shadow inset 0 0 6px transparent
    background-color $textColor
  /* 定义最上方和最下方的按钮 */
  &::-webkit-scrollbar-button
    height 0
.table
  width 100%
  font-size 12px
  padding 2px 0
  cursor pointer
.icon
  width 17px
  height 17px
.warn-tables
  display flex
  justify-content center
  align-items center
  width 100%
.img
  width 17px
  height 17px
  vertical-align middle
  object-fit contain
.imgUrl
  width 33px
@media (max-width 1280px)
  .imgUrl
    width 15px
  .imggs
    margin-right 0px
</style>
